import {init as initSaola} from '@saola.ai/browser';

const SaolaVersion = 'v1.1.3';
export const initSaolaService = token => {
    initSaola(token, SaolaVersion);
};
